// Central definition of premium (license-gated) feature keys WITH labels.
// Add new premium features here only.
export const PREMIUM_FEATURES_MAP = {
	screenReader: "Screen reader",
	pageStructure: "Page Structure",
	dictionary: "Dictionary",
	magnifiImages: "Magnify Images",
	tooltips: "Tooltips",
	highlightHover: "Highlight Hover",
	contentScaling: "Content Scaling",
	biggerText: "Bigger Text",
	dyslexiaFriendly: "Dyslexia Friendly",
	colorSaturation: "Color Saturation",
	pointerTrail: "Pointer Trail",
	imageTrails: "Image Trails",
	clickSpark: "Click Spark",
	readingMask: "Reading mask",
	hideImages: "Hide images",
	hideLogo: "Hide Logo and Branding",
	sheetSidebar: "Sheet Sidebar",
	openKeyboardShortcuts: "Custom Keyboard Shortcuts",
	accessibilityProfile: "Accessibility Profile",
};

export const PREMIUM_FEATURE_KEYS = Object.keys(PREMIUM_FEATURES_MAP);
export const PREMIUM_FEATURE_LABELS = Object.values(PREMIUM_FEATURES_MAP);
export const isPremiumFeature = (key) => key in PREMIUM_FEATURES_MAP;
export const getPremiumLabel = (key) => PREMIUM_FEATURES_MAP[key] || key;
